import { z } from "zod";

export const emailLayerArtifactSchema = z.object({
  version: z.literal(1),
  content: z.string().min(1),
  width: z.number().int().positive(),
  height: z.number().int().positive(),
  fontRules: z.array(z.string()),
  fontFiles: z.array(
    z.object({
      fileId: z.string(),
      familyName: z.string(),
      weight: z.string(),
      style: z.string(),
      postscriptName: z.string().optional(),
      preferredFamily: z.string().optional(),
      preferredSubfamily: z.string().optional(),
      variationAxes: z
        .record(
          z.object({
            name: z.string(),
            min: z.number(),
            default: z.number(),
            max: z.number(),
          }),
        )
        .optional(),
      namedVariations: z.record(z.record(z.number())).optional(),
    }),
  ),
});

export type EmailLayerArtifact = z.infer<typeof emailLayerArtifactSchema>;
